import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarAreaConfiguracion } from '../../../actions/configuracion';

const EliminarArea = ({ area, reestablecerArea }) => {

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (area) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [area]);

    const handleClose = () => {
        setShow(false);
        reestablecerArea(null);   // mismo patrón que en categorías
    };

    const handleEliminar = async (tipo) => {
        if (!area || !area._id) return;

        const resp = await dispatch(
            eliminarAreaConfiguracion({ id: area._id, tipo })
        );

        if (resp && resp.success) {
            handleClose();
        }
        // si hay error, se muestra el alert y dejamos el modal abierto
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <div className="modal-header">
                <h5 className="modal-title">Eliminar área</h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"
                ></button>
            </div>

            <div className="modal-body">
                <p>
                    ¿Deseas eliminar a <strong>{area?.nombre}</strong>?
                </p>

                <div className="d-flex flex-column align-items-center">
                    <div className="mb-2">
                        <button
                            type="button"
                            className="btn btn-danger me-2"
                            onClick={handleClose}
                        >
                            ✖ No
                        </button>

                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => handleEliminar(1)}
                        >
                            ✔ Sí, solo área
                        </button>
                    </div>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => handleEliminar(2)}
                    >
                        ✔ Sí, área, organizadores y ubicaciones
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default EliminarArea;
